import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaPython, 
  FaHtml5, 
  FaCss3Alt, 
  FaDatabase, 
  FaGithub, 
  FaCode,
  FaServer,
  FaChartBar,
  FaCog,
  FaTools
} from 'react-icons/fa';

const Skills = () => {
  const allSkills = [
    // Languages
    { name: 'Python', icon: <FaPython size={32} className="text-blue-500" /> },
    { name: 'HTML', icon: <FaHtml5 size={32} className="text-orange-600" /> },
    { name: 'CSS', icon: <FaCss3Alt size={32} className="text-blue-600" /> },
    
    // Libraries
    { name: 'NumPy', icon: <FaChartBar size={32} className="text-blue-700" /> },
    { name: 'Pandas', icon: <FaChartBar size={32} className="text-purple-600" /> },
    { name: 'Matplotlib', icon: <FaChartBar size={32} className="text-orange-500" /> },
    
    // Backend
    { name: 'Flask', icon: <FaServer size={32} className="text-gray-800" /> },
    { name: 'REST APIs', icon: <FaCode size={32} className="text-blue-500" /> },
    
    // Database
    { name: 'SQLite', icon: <FaDatabase size={32} className="text-gray-600" /> },
    { name: 'SQL', icon: <FaDatabase size={32} className="text-blue-800" /> },
    { name: 'MongoDB', icon: <FaDatabase size={32} className="text-green-600" /> },
    
    // Tools
    { name: 'Git & GitHub', icon: <FaGithub size={32} className="text-gray-900" /> },
    { name: 'Tkinter', icon: <FaCog size={32} className="text-blue-600" /> },
    { name: 'Kaggle', icon: <FaTools size={32} className="text-blue-400" /> },
  ];

  return (
    <section id="skills" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Skills & Technologies
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Technologies and tools I use to bring ideas to life
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {allSkills.map((skill, index) => (
            <motion.div
              key={skill.name}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, y: -5 }}
              className="bg-white rounded-xl p-4 shadow-md hover:shadow-lg transition-all duration-300 text-center"
            >
              <div className="mb-3 flex justify-center">
                {skill.icon}
              </div>
              <div className="text-gray-700 font-medium text-sm">{skill.name}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
